/** IMPORTS */
import {IWall} from '../models/wall';
import {IPost} from '../models/post';
import {IComment} from '../models/comment';
import { User } from '../models/user';

/** ACTIONS */

/** USER */
export const USER_CHECK_SESSION = 'USER_CHECK_SESSION';
export const USER_CHECK_SESSION_SUCCESS = 'USER_CHECK_SESSION_SUCCESS';
export const USER_CHECK_SESSION_ERROR = 'USER_CHECK_SESSION_ERROR';
export const USER_CREATE = 'USER_CREATE';
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS'; 
export const USER_CREATE_ERROR = 'USER_CREATE_ERROR';
export const USER_SESSION_SET = 'USER_SESSION_SET';
export const USER_SESSION_SET_SUCCESS = 'USER_SESSION_SET_SUCCESS';
export const USER_SESSION_SET_ERROR = 'USER_SESSION_SET_ERROR';
export const USER_INFO_FORM_SUBMISSION = 'USER_INFO_FORM_SUBMISSION';
export const USER_INFO_FORM_SUBMISSION_SUCCESS = 'USER_INFO_FORM_SUBMISSION_SUCCESS';
export const USER_INFO_FORM_SUBMISSION_ERROR = 'USER_INFO_FORM_SUBMISSION_ERROR';
export const USER_INFO_FORM_CHECK = 'USER_INFO_FORM_CHECK';
export const USER_INFO_FORM_CHECK_SUCCESS = 'USER_INFO_FORM_CHECK_SUCCESS';
export const USER_INFO_FORM_CHECK_ERROR = 'USER_INFO_FORM_CHECK_ERROR';
export const USER_INFO_FORM_DISMISSED = 'USER_INFO_FORM_DISMISSED';
export const USER_INFO_FORM_DISMISSED_SUCCESS = 'USER_INFO_FORM_DISMISSED_SUCCESS';
export const USER_INFO_FORM_DISMISSED_ERROR = 'USER_INFO_FORM_DISMISSED_ERROR';
export const USER_CONTACT_FORM = 'USER_CONTACT_FORM';
export const USER_CONTACT_FORM_UPDATE = 'USER_CONTACT_FORM_UPDATE';
export const USER_CONTACT_FORM_UPDATE_SUCCESS = 'USER_CONTACT_FORM_UPDATE_SUCCESS';

/** WALLS */
export const REQUEST_WALL = 'REQUEST_WALL';
export const REQUEST_WALL_SUCCESS = 'REQUEST_WALL_SUCCESS';
export const REQUEST_WALL_ERROR = 'REQUEST_WALL_ERROR';

/** POSTS */
export const ADD_POST = 'ADD_POST';
export const ADD_POST_SUCCESS = 'ADD_POST_SUCCESS';
export const ADD_POST_ERROR = 'ADD_POST_ERROR';
export const UPDATE_POST = 'UPDATE_POST';
export const UPDATE_POST_SUCCESS = 'UPDATE_POST_SUCCESS';
export const UPDATE_POST_ERROR = 'UPDATE_POST_ERROR';
export const REMOVE_POST = 'REMOVE_POST';
export const REMOVE_POST_SUCCESS = 'REMOVE_POST_SUCCESS';
export const REMOVE_POST_ERROR = 'REMOVE_POST_ERROR';
export const REQUEST_POST = 'REQUEST_POST';
export const REQUEST_POST_SUCCESS = 'REQUEST_POST_SUCCESS';
export const REQUEST_POST_ERROR = 'REQUEST_POST_ERROR';
export const REQUEST_POSTS = 'REQUEST_POSTS';
export const REQUEST_POSTS_SUCCESS = 'REQUEST_POSTS_SUCCESS';
export const REQUEST_POSTS_ERROR = 'REQUEST_POSTS_ERROR';
export const UPDATE_FEATUREDPOST = 'UPDATE_FEATUREDPOST';
export const UPDATE_FEATUREDPOST_SUCCESS = 'UPDATE_FEATUREDPOST_SUCCESS';
export const UPDATE_FEATUREDPOST_ERROR = 'UPDATE_FEATUREDPOST_ERROR';
export const REQUEST_POSTS_METADATA = 'REQUEST_POSTS_METADATA';
export const REQUEST_POSTS_METADATA_SUCCESS = 'REQUEST_POSTS_METADATA_SUCCESS';
export const REQUEST_POSTS_METADATA_ERROR = 'REQUEST_POSTS_METADATA_ERROR';

/** COMMENTS */
export const ADD_COMMENT = 'ADD_COMMENT';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_ERROR = 'ADD_COMMENT_ERROR';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_ERROR = 'UPDATE_COMMENT_ERROR';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';
export const REMOVE_COMMENT_SUCCESS = 'REMOVE_COMMENT_SUCCESS';
export const REMOVE_COMMENT_ERROR = 'REMOVE_COMMENT_ERROR';
export const REQUEST_COMMENT = 'REQUEST_COMMENT';
export const REQUEST_COMMENT_SUCCESS = 'REQUEST_COMMENT_SUCCESS';
export const REQUEST_COMMENT_ERROR = 'REQUEST_COMMENT_ERROR';
export const REQUEST_COMMENTS = 'REQUEST_COMMENTS';
export const REQUEST_COMMENTS_SUCCESS = 'REQUEST_COMMENTS_SUCCESS';
export const REQUEST_COMMENTS_ERROR = 'REQUEST_COMMENTS_ERROR';

/** LIKES */
export const UPDATE_LIKE = 'UPDATE_LIKE';
export const UPDATE_LIKE_SUCCESS = 'UPDATE_LIKE_SUCCESS';
export const UPDATE_LIKE_ERROR = 'UPDATE_LIKE_ERROR';

/** HANDLERS */

/** USER */
export const getUserSuccess = (user:User) => ({type: USER_CHECK_SESSION_SUCCESS, payload: user});
export const getUserError = () => ({type: USER_CHECK_SESSION_ERROR});
export const setUserSuccess = (user:any) => ({type: USER_CREATE_SUCCESS, payload: user});
export const setUserError = () => ({type: USER_CREATE_ERROR});
export const setUserSessionSuccess = (user:any) => ({type: USER_SESSION_SET_SUCCESS, payload: user});
export const setUserSessionError = () => ({type: USER_SESSION_SET_ERROR});
export const setUserInfoSubmissionSuccess = (user:any) => ({type: USER_INFO_FORM_SUBMISSION_SUCCESS, payload: user});
export const setUserInfoSubmissionError = () => ({type: USER_INFO_FORM_SUBMISSION_ERROR});
export const setUserInfoDismissedSuccess = (user:any) => ({type: USER_INFO_FORM_DISMISSED_SUCCESS, payload: user});
export const setUserInfoDismissedError = () => ({type: USER_INFO_FORM_DISMISSED_ERROR});
export const setFormValidSuccess = (validation:any) => ({type: USER_CONTACT_FORM_UPDATE_SUCCESS, payload: validation});

/** WALLS */
export const getWallSuccess = (wall:IWall) => ({type: REQUEST_WALL_SUCCESS, payload: wall}); 
export const getWallError = () => ({type: REQUEST_WALL_ERROR});

/** POSTS */
export const addPostSuccess = (post:IPost) => ({type: ADD_POST_SUCCESS, payload:post}); 
export const addPostError = () => ({type: ADD_POST_ERROR}); 
export const updatePostSuccess = (post:IPost) => ({type: UPDATE_POST_SUCCESS, payload:post}); 
export const updatePostError = () => ({type: UPDATE_POST_ERROR}); 
export const removePostSuccess = (id:string) => ({type: REMOVE_POST_SUCCESS, payload:id}); 
export const removePostError = () => ({type: REMOVE_POST_ERROR}); 
export const getPostSuccess = (post:IPost) => ({type: REQUEST_POST_SUCCESS, payload: post}); 
export const getPostError = () => ({type: REQUEST_POST_ERROR});
export const getPostsSuccess = (posts:any) => ({type: REQUEST_POSTS_SUCCESS, payload: posts}); 
export const getPostsError = () => ({type: REQUEST_POSTS_ERROR});
export const getPostsMetadataSuccess = (data:any) => ({type: REQUEST_POSTS_METADATA_SUCCESS, payload: data});
export const getPostsMetadataError = (data:any) => ({type: REQUEST_POSTS_METADATA_ERROR});

/** COMMENTS */
export const addCommentSuccess = (comment:IComment) => ({type: ADD_COMMENT_SUCCESS, payload:comment}); 
export const addCommentError = () => ({type: ADD_COMMENT_ERROR}); 
export const updateCommentSuccess = (comment:IComment) => ({type: UPDATE_COMMENT_SUCCESS, payload:comment}); 
export const updateCommentError = () => ({type: UPDATE_COMMENT_ERROR}); 
export const removeCommentSuccess = (id:string) => ({type: REMOVE_COMMENT_SUCCESS, payload:id}); 
export const removeCommentError = () => ({type: REMOVE_COMMENT_ERROR}); 
export const getCommentSuccess = (comment:IComment) => ({type: REQUEST_COMMENT_SUCCESS, payload: {comment}}); 
export const getCommentError = () => ({type: REQUEST_COMMENT_ERROR});
export const getCommentsSuccess = (comments:any) => ({type: REQUEST_COMMENTS_SUCCESS, payload: comments}); 
export const getCommentsError = () => ({type: REQUEST_COMMENTS_ERROR});

/** LIKES */
export const likeSuccess = (data:any) => ({type: UPDATE_LIKE_SUCCESS, payload: data});
export const likeError = () => ({type: UPDATE_LIKE_ERROR});